import { isMobile } from '@/utils/mobile.util';

import updateHistoryMobile from './mobile';
import updateHistoryView from './update-history.view';

export default isMobile ? updateHistoryMobile : updateHistoryView;
